import React from 'react';
import { Tooltip } from '@mui/material';

const HtmlTooltip = ({ children, title, withBorder = false, wrapperStyle = {}, ...rest }) => (
  <Tooltip
    slotProps={{
      tooltip: {
        sx: (theme) => ({
          backgroundColor: theme.palette.common.white,
          color: 'rgba(0, 0, 0, 0.87)',
          maxWidth: 500,
          boxShadow: theme.shadows[25],
          border: withBorder ? `1px solid ${theme.palette.divider}` : 'none',
        }),
      },
      arrow: {
        sx: (theme) => ({
          color: theme.palette.common.white,
        }),
      },
    }}
    title={title}
    {...rest}
  >
    <span style={wrapperStyle}>{children}</span>
  </Tooltip>
);

export default HtmlTooltip;
